import { saveConfig, getConfig } from "@/api/common";
import store from "@/store";

export const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1000;

export const parseNoticeDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const isNoticeOlderThanOneMonth = (value, now = Date.now()) => {
    const date = parseNoticeDate(value);
    if (!date) return false;
    return now - date.getTime() > ONE_MONTH_MS;
};

/**
 * 从未读公告中选出需要自动弹出的一条。
 * 超过一个月的未读公告会标为已读，不再自动弹出。
 */
export const pickAutoShowNotice = (list, cacheConfig, now = Date.now()) => {
    const config = { ...(cacheConfig || {}) };
    const unread = (list || []).filter(
        (item) => config[String(item.key)] !== "true",
    );
    const expiredKeys = [];
    const unreadWithinMonth = unread.filter((item) => {
        const date = parseNoticeDate(item.timestamp);
        if (!date) return true;
        if (now - date.getTime() > ONE_MONTH_MS) {
            expiredKeys.push(item.key);
            return false;
        }
        return true;
    });
    expiredKeys.forEach((id) => {
        config[String(id)] = "true";
    });
    if (unreadWithinMonth.length === 0) {
        return { needShowKey: null, config, expiredKeys };
    }
    unreadWithinMonth.sort((a, b) => {
        const dateA = parseNoticeDate(a.timestamp);
        const dateB = parseNoticeDate(b.timestamp);
        if (!dateA || !dateB) return 0;
        return dateB.getTime() - dateA.getTime();
    });
    return {
        needShowKey: unreadWithinMonth[0].key,
        config,
        expiredKeys,
    };
};

export const getUpdateNotesKnowConfig = () => {
    return new Promise(async (resolve) => {
        const { userId } = store.state.user;
        const dictKey = `update_notes_know_${userId}`;
        const isKnowNoteOld1 = localStorage.getItem("isKnowNotes-1");
        const isKnowNoteOld2 = localStorage.getItem("isKnowNotes-2");
        const isKnowNotesInvite = localStorage.getItem("isKnowNotes-invite");
        if (userId) {
            try {
                const configRes = await getConfig({ dictKey });
                const { dictValue } = configRes.data.data;
                const cacheConfig = JSON.parse(dictValue);
                if (isKnowNoteOld1) {
                    cacheConfig.notes1 = isKnowNoteOld1;
                }
                if (isKnowNoteOld2) {
                    cacheConfig.notes2 = isKnowNoteOld2;
                }
                if (isKnowNotesInvite) {
                    cacheConfig.notesInvite = isKnowNotesInvite;
                }
                resolve(cacheConfig);
            } catch (err) {
                // 为了兼容之前的更新公告读取情况
                resolve({
                    notes1: isKnowNoteOld1,
                    notes2: isKnowNoteOld2,
                    notesInvite: isKnowNotesInvite,
                });
            }
        } else {
            resolve({
                notes1: isKnowNoteOld1,
                notes2: isKnowNoteOld2,
                notesInvite: isKnowNotesInvite,
            });
        }
    });
};

export const saveUpdateNotesKnowConfig = async (value) => {
    const { userId } = store.state.user;
    if (userId) {
        const dictKey = `update_notes_know_${userId}`;
        return await saveConfig({
            dictKey,
            dictValue:
                typeof value === "string" ? value : JSON.stringify(value),
        });
    }
};
